// Attendance-report locking is per volunteer, not per report.
// The coordinator credits volunteers one at a time (AttendanceReportsTab.creditVolunteer), so a
// report is often half handled: whatever the coordinator already touched must stay frozen for the
// requester, while the rest stays editable.

// A volunteer is frozen once the coordinator credited them, or once the whole report was closed
// with "סמן כטופל" - that button is the coordinator declaring every row handled.
export const isVolunteerLocked = (volunteer, report) =>
    report?.status === 'processed' || volunteer?.credited === true

export const editableVolunteers = (report) =>
    (report?.volunteers || []).filter(volunteer => !isVolunteerLocked(volunteer, report))

export const lockedVolunteers = (report) =>
    (report?.volunteers || []).filter(volunteer => isVolunteerLocked(volunteer, report))

// Nothing left for the requester to answer or correct - the report drops out of their list
export const isReportFullyHandled = (report) => editableVolunteers(report).length === 0

// Mixed report: some rows already handled, others still open
export const hasLockedVolunteers = (report) => lockedVolunteers(report).length > 0
